import {Component,  OnInit} from '@angular/core';
import {language} from '../../../language/vn';
import {FormGroup, FormControl, FormBuilder, Validators} from '@angular/forms';
import {LinhVucVanBan} from '../../../models/danhmuc/linhvucvanban';
import { ToastrService } from 'ngx-toastr';
import {first} from 'rxjs/operators';
import {validateEmpty} from '../../../global/custom-validate';
import {BsModalService} from 'ngx-bootstrap/modal';
import {ConfirmDialogComponent} from '../../dialog/confirmdialog.component';
import {environment} from '../../../../environments/environment';
import {LinhVucVanBanService} from '../../../service/danhmuc/service-linhvucvanban';
import {Sessioncommand} from '../../../global/sessioncommand';
import {NavItemService} from '../../../service/staff/service-navitem';
import {RolePermissionService} from '../../../service/security/service-rolepermission';

@Component({
  templateUrl: './linhvucvanban.component.html'
})
export class LinhVucVanBanComponent implements OnInit {
  private language = language;
  private totalItems: number = 0;
  private currentPage: number   = environment.currentPage;
  private maxSize: number = environment.pageMaxRecord;
  private numPages: number = environment.numberPages;
  private frmGroup: FormGroup;
  private isEdit: boolean = false;
  private isRefresh: boolean = false;
  private dataList: LinhVucVanBan[];
  private submitValidate = false;
  private keyword: string = '';
  private permissionView: boolean = false;
  private permissionAdd: boolean = false;
  private permissionUpdate: boolean = false;
  private permissionDelete: boolean = false;
  private moduleName:  string = 'egov.danhmuc.linhvucvanban';
  constructor( private dataService: LinhVucVanBanService,
               private formBuilder: FormBuilder,
               private toastr: ToastrService,
               private bsModalService: BsModalService,
               private rolePermissionService: RolePermissionService

  ) {
  }
  ngOnInit(): void {
    this.rolePermissionService.checkPermissionByModule(Sessioncommand.staffId, this.moduleName
    ).subscribe( x => {
      this.permissionView = x.findIndex(y => y.action === environment.view) !== -1;
      if (this.permissionView)
        this.search(this.keyword);
      else
        this.rolePermissionService.redirectAccesDenied();
      this.permissionAdd = x.findIndex(y => y.action === environment.add) !== -1;
      this.permissionUpdate = x.findIndex(y => y.action === environment.update) !== -1;
      this.permissionDelete = x.findIndex(y => y.action === environment.delete) !== -1;
    });
    this.frmGroup = new FormGroup({
      id: new FormControl('0'),
      tenLinhVuc: new FormControl(),
      stt: new FormControl()
    });
    this.frmGroup = this.formBuilder.group({
      tenLinhVuc: ['' , Validators.compose([validateEmpty]) ],
      stt: ['', Validators.compose([validateEmpty, Validators.pattern('[0-9]*')])],
      id: ['', Validators.nullValidator]
    });



  }
  private showConfirmationModal(id: number): void {
    if(this.permissionDelete) {
      const modal = this.bsModalService.show(ConfirmDialogComponent);
      (<ConfirmDialogComponent>modal.content).showConfirmationModal(
        language.message,
        language.confirm_delete_question,
        language.yes,
        language.no
      );
      (<ConfirmDialogComponent>modal.content).onClose.subscribe(result => {
        if (result === true) {
          this.deleteItem(id);
        }
      });
    }
  }
  get f() { return this.frmGroup.controls; }
  edit(id: number) {
    this.isEdit = true;
    this.dataService.getById(id).pipe(first())
      .subscribe(x => this.frmGroup.patchValue(x));

  }
  search(keyword)
  {
    this.keyword = keyword;
    if(this.permissionView) {
      this.dataService.findAllByPaging(keyword, this.currentPage, this.maxSize).subscribe(dataList => this.dataList = dataList);
      this.dataService.getCountByKeyword(keyword).subscribe(recordCount => this.totalItems = recordCount);
    }
  }
  refresh()
  {
    this.isEdit = false;
    this.frmGroup.setValue({id: 0, tenLinhVuc: '', stt: '' });
  }
  createItem ()
  {
    if(this.permissionAdd) {
      this.dataService.add(this.frmGroup.value).subscribe({
        next: () => {
          this.toastr.success(language.add_success_record, language.message);
          this.search(this.keyword);

        },
        error: error => {
          this.toastr.error(language.error, language.message);
        }
      });
    }
  }
  updateItem()
  {
    if(this.permissionUpdate)
    {
      this.dataService.update(this.frmGroup.value).subscribe({
        next: () => {
          this.toastr.success(language.update_success_record, language.message);
          this.search(this.keyword);

        },
        error: error => {
          this.toastr.error(language.error, language.message);
        }
      });
    }
  }
  deleteItem(id: number)
  {
    this.dataService.delete(id).subscribe({
      next: () => {
        this.toastr.success(language.delete_success_record, language.message);
        this.search(this.keyword);

      },
      error: error => {
        this.toastr.error(language.error, language.message);
      }
    });
  }
  onSubmit()
  {
    this.submitValidate = true;
    if(this.frmGroup.invalid)
      return;
    if (this.isEdit)
      this.updateItem();
    else
      this.createItem();
  }
  pageChanged(event: any): void {
    this.currentPage = event.page;
    this.search(this.keyword);

  }
}
